import React from 'react';
import ContentLayout from '../../../components/ContentLayout';
import Tabs from '../../../components/Tabs';
import props from '../../../lib/contentLayoutProps/the-kingston-difference/layoutProps';

import bilingualism from './bilingualism@large.jpg';
import ibpyp from './ibpyp@large.jpg';

const tabs = ['雙語教學', '國際文憑小學課程'];

/* eslint-disable react/prop-types */
export default class extends React.Component {
  state = {
    tab: 0,
  };

  render() {
    const { tab } = this.state;

    return (
      <ContentLayout {...props} locale="zh" pageKey="approaches-to-learning">
        <h1>京斯敦教學方法</h1>
        <Tabs tabs={tabs} onChangeTab={index => this.setState({ tab: index })} />
        {tab === 0 && (
          <React.Fragment>
            <p>
              雙語教學是本校的獨特之處。京斯敦使用普通話及英語授課，期望學生能使用兩種語言學習及參與教學活動。每班有兩位合資格的班主任，母語分別為英語及普通話。
            </p>
            <p>學生每天會有一部分時間使用英語上課，一部分時間使用普通話上課，餘下時間為雙語課。</p>
            <p>
              我們為學生的雙語能力引以為傲。在國際文憑小學課程的框架下，小班教學及極佳的師生比例為雙語教學奠定重要的根基。
            </p>
            <img src={bilingualism} alt="Bilingualism" />
          </React.Fragment>
        )}
        {tab === 1 && (
          <React.Fragment>
            <p>
              京斯敦鼓勵學生透過真實和親身體驗投入參與學習。教學方針以探究為本，並以概念驅動學習，提升學生對語言及文化的理解，有助其探究重要的國際議題。京斯敦致力培養學生成為積極的終生學習者。
            </p>
            <img src={ibpyp} alt="IBPYP" />
          </React.Fragment>
        )}
      </ContentLayout>
    );
  }
}
